import React from 'react';
import styles from './FreemiumNotificationBar/styles.module.css';
import { ReactComponent as CautionAlert } from '../../assets/images/caution.svg';
import { ReactComponent as MaxedOutAlert } from '../../assets/images/maxed-out.svg';

export const PRODUCT_PLANS_PAGE_URL = '/account/settings/subscription/purchase/plans';

export const FREEMIUM_MODAL = {
  btnCaption: 'Upgrade Now',
  title: 'PagerDuty Free Plan Account Limits',
  body: () => (
    <div>
      <div>
        <p>
          Your PagerDuty free account plan includes:
        </p>
        <ul>
          <li>Up to 5 users</li>
          <li>Up to 1 schedule and escalation policy</li>
          <li>Up to 100 SMS notifications per month</li>
        </ul>
      </div>
      <p>
        Want to move to unlimited?
        <br />
        Check out our other plans.
      </p>
    </div>
  ),
  namespace: 'freemiumNurtureBar',
  width: '500px'
};

const NOTIFICATION_TYPES = {
  default: {
    id: 'default',
    alertImage: null,
    segmentNotificationType: 'default',
  },
  caution: {
    id: 'caution',
    alertImage: <CautionAlert />,
    segmentNotificationType: 'caution',
  },
  maxedOut: {
    id: 'maxedOut',
    alertImage: <MaxedOutAlert />,
    segmentNotificationType: 'max',
  },
};

export const FREEMIUM_LIMITS = {
  users: {
    url: '/users',
    type: 'users',
    limitMax: 5,
    ctaType: 'Users',
    color: {
      default: styles.blue,
      caution: styles.orange,
      maxedOut: styles.red,
    }
  },
  schedules: {
    url: '/schedules',
    type: 'schedules',
    limitMax: 1,
    ctaType: 'Schedules',
    color: {
      default: styles.blue,
      caution: styles.orange,
      maxedOut: styles.orange,
    }
  },
  escalationPolicies: {
    url: '/escalation_policies',
    type: 'escalation policies',
    limitMax: 1,
    ctaType: 'Escalation',
    color: {
      default: styles.blue,
      caution: styles.orange,
      maxedOut: styles.orange,
    }
  },
};

export const FREEMIUM_DEFAULT_NOTIFICATION = {
  notification: {
    description: () => (
      <span>
        You are using PagerDuty&apos;s free plan.&nbsp;
        <span className={styles.freemiumLimitLink}>Restriction and monthly limits apply.</span>
        &nbsp;To move to unlimited, check out our other plans.
      </span>
    ),
    modal: FREEMIUM_MODAL,
    type: NOTIFICATION_TYPES.default,
  },
  limit: {
    color: {
      default: styles.blue
    }
  }
};

export const FREEMIUM_LIMIT_NOTIFICATIONS = {
  caution: {
    description: limitType => (
      <span>
        {`You are about to hit your limit for ${limitType}.`}
      </span>
    ),
    modal: FREEMIUM_MODAL,
    type: NOTIFICATION_TYPES.caution,
  },
  maxedOut: {
    description: limitType => (
      <span>
        {`You have hit your limit for ${limitType}. You will no longer be able to add ${limitType}.`}
      </span>
    ),
    modal: FREEMIUM_MODAL,
    type: NOTIFICATION_TYPES.maxedOut,
  },
  default: {
    users: {
      description: () => (
        <span>
          Your plan includes up to 5 users for free.
          To get additional user seats, check out our other plans.
        </span>
      ),
      modal: FREEMIUM_MODAL,
      type: NOTIFICATION_TYPES.default,
    },
    schedules: {
      description: () => (
        <span>
          Your plan includes up to 1 schedule for free.
          To move to unlimited, check out our other plans.
        </span>
      ),
      modal: FREEMIUM_MODAL,
      type: NOTIFICATION_TYPES.default,
    },
    escalationPolicies: {
      description: () => (
        <span>
          Your plan includes up to 1 escalation policy for free.
          To move to unlimited, check out our other plans.
        </span>
      ),
      modal: FREEMIUM_MODAL,
      type: NOTIFICATION_TYPES.default,
    },
  },
};
